import React from 'react'
import Skeleton from 'react-loading-skeleton'

const CardSkeleton = ({cards}) => {
  return (
    Array(cards)
        .fill(0)
        .map((item,i)=>(
            <div className='rounded-xl px-6 shadow-2xl mb-10 md:mb-6 lg:mb-4 max-[767px]:mx-auto max-w-[300px] bg-[radial-gradient(circle at center, #000000, #292929)] mt-20'
                key={i}>
                <div className="flex flex-col relative items-center">
                    <div className='absolute -top-16'>
                        <Skeleton circle width={96} height={96}/>
                    </div>
                    <div className='flex-1 mt-12 pb-2'>
                        <Skeleton containerClassName='flex-1 ' width={150} />
                    </div>
                    <div>
                        <Skeleton  width={100}/>
                    </div>
                    <div className='pt-6 pb-4'>
                        <Skeleton  width={250} count={2} />
                    </div>
			        <hr className="h-px w-[90%] border border-secondary bg-secondary my-6 "/>
                    <div className='flex gap-x-10 pb-4'>
                        <Skeleton  width={30} height={30}/>
                        <Skeleton  width={30} height={30}/>
                    </div>
                </div>
            </div>
        ))
    
  )
}

export default CardSkeleton